import { Modal } from "@mui/material";
import styled from "styled-components";
import Colors from "../../constants/Colors";

export const PainelConsultsCardModal = styled(Modal)<{
  useBackgroundColor?: boolean;
}>`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ useBackgroundColor }) =>
    useBackgroundColor && "background-color: rgba(0, 0, 0, 0.3);"}
`;
export const PainelConsultsCardModalContainer = styled.div`
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 80vw;
  width: auto;
  overflow: scroll;
  background-color: #ffffff;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`;

export const ModalPainelConsultsCardContainer = styled.div`
  padding: 36px 102px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 760px) {
    padding: 10px;
    width: 100%;
  }
`;

export const ModalPainelConsultsMedicCardContainer = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  gap: 10px;
  width: 100%;
  /* justify-content: center; */
`;

export const ModalPainelConsultsTextCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalPainelConsultsTimeCardContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  gap: 10px;
  align-items: center;
`;

export const ModalPainelConsultsHoursContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  ${Colors.SPM500}
`;

export const ModalPainelConsultsHourCard = styled.div`
  display: flex;

  border-radius: 4px;

  text-align: center;
  @media screen and (max-width: 760px) {
    text-align: left;
  }
  background: ${Colors.SPM50};
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  max-height: 30px;
  gap: 10px;
`;

export const ModalPainelConsultsSubTextContainer = styled.div`
  text-align: left;
`;

export const ModalPainelConsultsButtonsContainer = styled.div`
  display: flex;

  width: 100%;
  gap: 10px;

  align-items: center;
  justify-content: center;
`;

export const ContainerInfoUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
`;

export const InfoUserModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin-left: 10px;
    font-weight: 500;
    color: #101828;
  }
`;

export const DivHorario = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
`;

export const DivStatusPacient = styled.div`
width: 75%;
font-weight: 500;
font-size: 18px;
line-height: 20px;
/* identical to box height, or 125% */


color: #000000;

`;